import Divider from '@zenbusiness/zui/Divider';
import Link from '@zenbusiness/zui/Link';
import { styled } from '@zenbusiness/zui/styles';

const LinkStyles = () => ({
  cursor: 'pointer',
  textDecoration: 'underline'
});

export const AlertStyle = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  backgroundColor: `${theme.palette.background.grey.light}`,
  border: `1px solid ${theme.palette.border.main}`
});

export const DividerStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.blue.main,
  borderRadius: '12px',
  borderWidth: '4px'
});

export const AlertStyled = styled('div')(AlertStyle);
export const DividerStyled = styled(Divider)(DividerStyle);
export const LinkStyled = styled(Link)(LinkStyles);
